// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"222":"e89437a7","236":"30ddc83f","869":"30ddc83f","952":"c67e517e"}[chunkId] + ".chunk.css";
};